import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from '../utils/apiFetch.js';
import MovdNotice from '../design-system/MovdNotice.jsx';
import { movdTokens } from '../design-system/movdTokens.js';

const statusCopy = {
  pending: 'Awaiting mover acceptance',
  confirmed: 'Confirmed',
  in_progress: 'Move in progress',
  awaiting_customer_confirmation: 'Confirm completion',
  completed: 'Completed',
  cancelled: 'Cancelled',
  refunded: 'Refunded',
  payment_failed: 'Payment issue',
};

const statusTone = status => (status === 'completed' ? movdTokens.color.state.success : status === 'cancelled' ? movdTokens.color.state.error : movdTokens.color.action.primary);

export default function CustomerBookingsPage() {
  const navigate = useNavigate();
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    apiFetch('/api/customer/bookings', { credentials: 'include' })
      .then(async response => {
        const data = await response.json().catch(() => []);
        if (!response.ok) throw new Error(data.error || 'Unable to load bookings.');
        setBookings(data);
      })
      .catch(loadError => setError(loadError.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ maxWidth: 1040, margin: '0 auto', padding: 'clamp(24px, 5vw, 48px) 20px' }}>
      <p style={{ margin: 0, color: movdTokens.color.action.primary, fontWeight: 800, letterSpacing: '.1em', fontSize: 11, textTransform: 'uppercase' }}>Customer portal</p>
      <h1 style={{ margin: '4px 0 0', color: '#0F172A', fontSize: 'clamp(2rem, 5vw, 3rem)', fontWeight: 900 }}>Bookings</h1>
      <p style={{ color: movdTokens.color.content.secondary, marginBottom: 28 }}>Your complete MOVD booking history.</p>

      {loading && (
        <div style={{ display: 'grid', placeItems: 'center', padding: '64px 0' }}>
          <div aria-hidden="true" style={{ width: 32, height: 32, borderRadius: '50%', border: '3px solid rgba(0,0,0,.1)', borderTopColor: movdTokens.color.action.primary, animation: 'movd-spin 0.8s linear infinite' }} />
          <style>{'@keyframes movd-spin { to { transform: rotate(360deg); } }'}</style>
        </div>
      )}
      {!loading && error && <MovdNotice tone="error">{error}</MovdNotice>}
      {!loading && !error && bookings.length === 0 && <MovdNotice tone="info">Your bookings will appear here after you complete a move booking.</MovdNotice>}
      {!loading && !error && bookings.length > 0 && (
        <div style={{ display: 'grid', gap: 12 }}>
          {bookings.map(booking => (
            <div key={booking._id} style={{ background: '#fff', border: '1px solid #D9E2EC', borderRadius: 10, padding: 'clamp(16px, 3vw, 20px)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 16, flexWrap: 'wrap' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <div style={{ width: 40, height: 40, borderRadius: '50%', background: movdTokens.color.action.primary, color: '#fff', display: 'grid', placeItems: 'center', overflow: 'hidden', flexShrink: 0 }}>
                    {booking.mover?.logo || booking.mover?.profileImage ? <img src={booking.mover.logo || booking.mover.profileImage} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : '\uD83D\uDE9A'}
                  </div>
                  <div>
                    <p style={{ margin: 0, fontWeight: 850 }}>{booking.mover?.name || 'MOVD mover'}</p>
                    <p style={{ margin: 0, fontSize: 12, color: movdTokens.color.content.secondary }}>Booking {booking.jobNumber || booking._id}</p>
                  </div>
                </div>
                <span style={{ background: statusTone(booking.status), color: '#fff', borderRadius: 20, padding: '4px 12px', fontSize: 12, fontWeight: 800 }}>{statusCopy[booking.status] || booking.status}</span>
              </div>
              <div style={{ height: 1, background: '#E2E8F0', margin: '16px 0' }} />
              <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', color: movdTokens.color.content.secondary, fontSize: 14 }}>
                <span>{new Date(booking.moveDate).toLocaleDateString()}</span>
                <span>{booking.origin} → {booking.destination}</span>
              </div>
              <button type="button" onClick={() => navigate(`/customer-portal/booking/${booking._id}`)} style={{ marginTop: 12, background: 'transparent', border: 'none', color: movdTokens.color.action.primary, fontWeight: 800, cursor: 'pointer', padding: 0 }}>Open booking workspace →</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
